import { render } from "./AdManagement.vue?vue&type=template&id=197f065e"
import script from "./AdManagement.vue?vue&type=script&lang=js"
export * from "./AdManagement.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AdManagement.vue?vue&type=style&index=0&id=197f065e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__